/** @flow */
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from '../actions/authenticationActions';

type PasswordReset = {
  isResetting: boolean,
  error: ?Object,
};

export type AuthenticationState = {
  isAuthenticating: boolean,
  error: ?Object,
  passwordReset: PasswordReset,
};


const INITIAL_STATE: AuthenticationState = {
  isAuthenticating: false,
  error: undefined,
  passwordReset: {
    isResetting: false,
    error: undefined,
  },
};

export default (state: AuthenticationState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isAuthenticating: true,
        error: undefined,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticating: false,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticating: false,
        error: action.error,
      };
    case RESET_PASSWORD:
      return {
        ...state,
        passwordReset: {
          ...state.passwordReset,
          isResetting: true,
          error: undefined,
        },
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordReset: {
          ...state.passwordReset,
          isResetting: false,
        },
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        passwordReset: {
          ...state.passwordReset,
          isResetting: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/reducers/authenticationReducer.js